<template>
  <div>
    <div class="w95mg " v-if="!isObjectEmpty">
      <div class="tab-list whitebox  mb">
        <div class="chart-tab" :class="chartType == item.value ? 'active' : ''" @click="changeChartType(item)"
          v-for="(item, index) in chartTypeList" :key="index">
          {{ item.label }}
        </div>
      </div>
      <div class="whitebox charts-box">
        <el-select v-show="chartType == 4 || chartType == 5" v-model="pieType" placeholder="请选择图表类型"
          style="width: 200px" @change="changePieType">
          <el-option v-for="item in showLegendList" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
        <el-select v-show="chartType == 1" v-model="barChartType" placeholder="请选择图表类型" style="width: 200px"
          @change="changeBarType">
          <el-option v-for="item in barChartTypeList" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
        <div id="chart-box" class="chart-box"></div>
      </div>
    </div>
    <div v-else>
      <el-empty description="无数据"></el-empty>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      userdata: {},
      chartTypeList: [
        { label: "柱状图", value: 1 },
        { label: '折柱混合图', value: 2 },
        { label: "折线图", value: 3 },
        { label: "饼图", value: 4 },
        { label: '环形图', value: 5 },
      ],
      barChartTypeList: ["横向柱状图", "纵向柱状图"],
      barChartType: "纵向柱状图",
      chartType: 1,
      id: "",
      chartData: {},
      mychart: null,
      showLegendList: [],
      pieType: "",
      toolbox: {
        feature: {
          saveAsImage: { title: '保存为图片', pixelRatio: 5, type: 'jpeg', },
          dataView: { title: '数据视图', },
          magicType: {
            title: {
              stack: "堆叠",
              tiled: "平铺",
            },
            type: ["stack", "tiled"],
          },
          restore: { title: '还原', },
          datazoom: { title: '区域缩放', },
          zoomreset: { title: '区域缩放还原', },
        },
        right: "3%",
        top: 0,
      },
      colorList: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'], //echarts默认颜色
      // colorList:["#2E4F8B", "#375DA1", "#3D68B3", "#4472C4", "#A7B5DB", "#C3CCE5"],
    };
  },
  computed: {
    isObjectEmpty() {
      for (let key in this.chartData) {
        if (this.chartData.hasOwnProperty(key)) {
          return false;
        }
      }
      return true;
    }
  },
  created() {
    this.id = this.$route.query.id;
  },
  mounted() {
    this.userdata = this.getuseriformation();
    this.getDetail();
  },
  methods: {
    changeBarType(val) {
      this.barChartType = val;
      this.barChart("chart-box", this.chartData);
    },

    changePieType(val) {
      this.pieType = val;
      console.log("changePieType", val, this.chartData);
      for (const key in this.chartData) {
        if (this.chartData.hasOwnProperty(key)) {
          let temKey = this.trunKey(key);
          if (temKey == val) {
            //剔除其他数据
            let temArry = {};
            // 相等的一整条数据,包括键值对
            //    temArry.key = val;
            temArry[key] = this.chartData[key];
            this.pieChart("chart-box", temArry);
          }
        }
      }
    },
    getDetail() {
      var _this = this;
      var ajaxurl = this.$api.common.chart.detail() + "?id=" + this.id;
      // this.bus.$emit("loading", true);
      this.$axios
        .get(ajaxurl)
        .then(function (res) {
          console.log("图表列表", ajaxurl, res);
          if (res.data.success) {
            let data = res.data.data;
            _this.chartData = data;
            // _this.lineChart('chart-box', data);
            if (!_this.isObjectEmpty) {
              _this.$nextTick(() => {
                _this.barChart("chart-box", data);
              });
            }

            _this.bus.$emit("loading", false);
          } else {
          }
        })
        .catch(function (error) {
          // 请求失败处理 console.log(error);
        });
    },
    //切换图表
    changeChartType(item) {
      this.chartType = item.value;
      switch (this.chartType) {
        case 1:
          this.$nextTick(() => {
            this.barChart("chart-box", this.chartData);
          });
          break;
        case 2:
          this.$nextTick(() => {
            this.cpclChart("chart-box", this.chartData);
          });
          break;
        case 3:
          this.$nextTick(() => {
            this.lineChart("chart-box", this.chartData);
          });
          break;
        case 4:
          this.$nextTick(() => {
            this.pieChart("chart-box", this.chartData,);
          });
          break;
        case 5:
          this.$nextTick(() => {
            this.pieChart("chart-box", this.chartData,);
          });
          break;
      }
    },

    lineChart(el, data) {
      this.mychart = echarts.init(document.getElementById(el));
      this.mychart.clear();

      let xdata = []; // X轴数据
      let seriesData = []; // 系列数据
      let legendData = []; // 图例数据

      // 遍历数据，生成图表所需的数据结构
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const lineList = data[key]; // 当前系列的数据列表
          const legendName = this.trunKey(key); // 去掉后缀，生成图例名称

          // 提取数据，确保所有值都是有效的数字（包括 0）
          const series = {
            name: legendName, // 系列名称
            type: "line", // 折线图类型
            stack: "Total", // 堆叠名称
            data: lineList.map(item => {
              // 确保数据为有效数字，将 null 或 undefined 转换为 0
              return item.data === null || item.data === undefined ? 0 : item.data;
            }),
            label: {
              show: true, // 显示标签
              position: "top" // 标签位置
            }
          };

          // 如果 X 轴数据为空，初始化 X 轴数据
          if (xdata.length === 0) {
            xdata = lineList.map(item => item.label);
          }

          // 添加到系列数据和图例数据
          seriesData.push(series);
          legendData.push(legendName);
        }
      }

      // ECharts 配置
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        toolbox: this.toolbox, // 工具箱配置
        legend: {
          data: legendData, // 动态生成图例
          bottom: "10",
          left: "center",
          itemGap: 30,
          textStyle: {
            color: "#333",
            fontSize: 16
          }
        },
        xAxis: {
          type: "category",
          data: xdata,
          interval: 0,
          axisLine: {
            onZero: false,
            lineStyle: {
              color: "#333"
            }
          },
          axisLabel: {
            color: "#333",
            fontSize: 14
          },
          axisTick: {
            show: true
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#333",
            fontSize: 14
          }
        },
        series: seriesData,
        color: this.colorList // 自定义颜色列表
      };

      // 设置 ECharts 配置
      this.mychart.setOption(option, true);
    },
    pieChart(el, data, showList) {
      var _this = this;
      this.mychart = echarts.init(document.getElementById(el));
      this.mychart.clear();
      let legendName = "",
        seriesData = [],
        isPen = false,
        legendData = [];

      // data = showList ? data[showList] : data;
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          console.log(`键: ${key}, 值:`, data[key]);
          isPen = key.includes("P"); // 包含 "P" 是数据本来就是百分比数据了，后面的label不要显示百分百
          legendName = this.trunKey(key);
          legendData.push(legendName);
          //筛选
          seriesData = data[key];
          console.log(seriesData, showList, data[showList]);
          for (let i = 0; i < seriesData.length; i++) {
            seriesData[i].value = seriesData[i].data;
            seriesData[i].name = seriesData[i].label;
          }
        }
      }
      if (this.pieType == "") {
        this.showLegendList = legendData;
        this.pieType = legendData[legendData.length - 1];
      }
      console.log("-------------", seriesData, legendData, this.pieType, _this.chartType == 4 ? "" : '["40%", "70%"]');
      const option = {
        // title: {
        //     text: legendName,
        //     left: 'center'
        // },
        toolbox: {
          feature: {
            saveAsImage: { title: "保存为图片" },
            dataView: { title: "数据视图" },
            restore: { title: "还原" },
          },

          right: "3%",
          top: 0,
        },
        tooltip: {
          trigger: "item",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        legend: {
          show: true,
          // data: legendData,
          bottom: "10",
          left: "center",
          itemGap: 30,
          textStyle: {
            color: "#333",
            fontSize: 16,
          },
        },
        series: [
          {
            radius: _this.chartType == 4 ? "45%" : ["25%", "45%"],//环形图
            name: legendName,
            type: "pie",
            data: seriesData,
            label: {
              show: true,
              formatter: isPen ? "{b} : {c}" : "{b} : {c}({d}%)",
              fontSize: 14,
            },

            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
        color: this.colorList,
      };
      this.mychart.setOption(option, true);;
    },
    barChart(el, data) {
      console.log("柱状图", data);
      this.mychart = echarts.init(document.getElementById(el));
      console.log(this.mychart, document.getElementById(el));
      this.mychart.clear();
      var xdata = [],
        ydata = [],
        seriesData = [],
        legendData = [],
        legendName = "";
      console.log(data);
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          console.log(`键: ${key}, 值:`, data[key]);
          document.title = key;

          let lineList = data[key];
          let lineArry = [];
          for (let i = 0; i < lineList.length; i++) {
            console.log(lineList[i]);
            lineArry.push(lineList[i].data);
          }
          //   xdata = lineList.map((item) => item.label);
          if (this.barChartType == "纵向柱状图") {
            ydata = { type: "value", axisLabel: { color: '#333', fontSize: 14 }, };
            xdata = {
              type: "category",
              data: lineList.map((item) => item.label),
              axisLabel: { color: '#333', fontSize: 14 },
            };
          } else {
            ydata = { type: "category", data: lineList.map((item) => item.label), axisLabel: { color: '#333', fontSize: 14 }, };
            xdata = { type: "value", axisLabel: { color: '#333', fontSize: 14 }, };
          }
          legendName = this.trunKey(key);
          legendData.push(legendName);
          seriesData.push({
            name: legendName,
            type: "bar",
            barGap: 0,
            label: {
              show: true,
              position: "top",
            },
            emphasis: {
              focus: "series",
            },
            data: lineArry,
          });
        }
      }
      const option = {
        title: {
          // text: legendName,
          // subtext: '纯属虚构'
        },
        textStyle: {
          fontSize: 14,
          color: "#333",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          show: true,
          data: legendData,
          bottom: "10",
          left: "center",
          itemGap: 30,
          textStyle: {
            color: "#333",
            fontSize: 16,
          },
        },
        toolbox: this.toolbox,
        xAxis: xdata,
        yAxis: ydata,
        series: seriesData,
        color: this.colorList,
      };
      // this.mychart.setOption(option,true);;
      this.mychart.setOption(option, true);
    },


    cpclChart(el, data) {
  this.mychart = echarts.init(document.getElementById(el));
  this.mychart.clear();

  let xdata = []; // X轴数据
  let seriesData = []; // 系列数据
  let legendData = []; // 图例数据

  // 提取数据
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const lineList = data[key];
      const isLine = key.includes("B"); // 包含 "B" 的是折线图
      const seriesName = this.trunKey(key); // 去掉 "-A" 和 "-B" 后缀

      // 提取 x 轴数据（仅在第一次循环时提取）
      if (xdata.length === 0) {
        xdata = lineList.map(item => item.label);
      }

      // 创建 series 数据
      seriesData.push({
        name: seriesName,
        type: isLine ? "line" : "bar",
        yAxisIndex: isLine ? 1 : 0, // 折线图使用第二个 Y 轴，柱状图使用第一个 Y 轴
        emphasis: {
          focus: "series"
        },
        label: {
          show: true, // 显示标签
          position: isLine ? "top" : "insideTop", // 折线图标签显示在顶部，柱状图标签显示在柱子内部顶部
          formatter: '{c}'
        },
        data: lineList.map(item => item.data)
      });

      // 添加到图例数据
      legendData.push(seriesName);
    }
  }

  // ECharts 配置
  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow"
      }
    },
    toolbox: this.toolbox, // 工具箱配置
    legend: {
      show: true,
      bottom: "10",
      itemGap: 30,
      data: legendData, // 使用处理后的图例名称
      textStyle: {
        color: "#333",
        fontSize: 16 // 图例字体大小调整为16号
      }
    },
    grid: {
      top: "10%",
      left: "5%", // 为左侧 Y 轴留出更多空间
      right: "5%", // 为右侧 Y 轴留出更多空间
      bottom: "5%",
      containLabel: true // 确保标签在图表区域内显示
    },
    xAxis: {
      type: "category",
      data: xdata,
      axisLine: {
        lineStyle: {
          color: "#333"
        }
      },
      axisLabel: {
        color: "#333",
        fontSize: 14 // X轴字体大小调整为14号
      }
    },
    yAxis: [
      {
        type: "value",
        name: "柱状图数据", // 第一个 Y 轴（柱状图）
        position: "left",
        axisLine: {
          lineStyle: {
            color: "#333"
          }
        },
        axisLabel: {
          color: "#333",
          fontSize: 14 // Y轴字体大小调整为14号
        }
      },
      {
        type: "value",
        name: "折线图数据", // 第二个 Y 轴（折线图）
        position: "right",
        axisLine: {
          lineStyle: {
            color: "#333"
          }
        },
        axisLabel: {
          color: "#333",
          fontSize: 14 // Y轴字体大小调整为14号
        },
        splitLine: {
          show: false // 隐藏折线图 Y 轴的网格线
        }
      }
    ],
    series: seriesData
  };

  // 设置 ECharts 配置
  this.mychart.setOption(option, true);
},
    trunKey(key) {
      return key.replace(/-A|-B|-P/g, "");
    }

  },
};
</script>

<style lang="scss">
.tab-list {
  overflow: hidden;

}

.charts-box {
  height: calc(100vh);
}

.chart-tab {
  width: 100px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  float: left;

  &:hover,
  &.active {
    background: #f0f7ff;
    cursor: pointer;
    border-top: 2px solid #409eff;
  }
}

.chart-box {
  // border: 1px solid red;
  padding-top: 60px;
  margin: 0 auto;
  width: 800px;
  height: 730px;
  // width: 100%;
  // height: 830px;
}
</style>